import React, { useState, useEffect } from "react";
import ChatInterface from "./ChatInterface";


export default function ChatPage({ user }) {
  return (
    <div className="h-[calc(100vh-175px)] bg-gray-50">
      <div className="max-w-7xl mx-auto h-full flex flex-col">
        {/* Tab Content */}
        <div className="flex-1 flex flex-col py-4 px-2 min-h-0">
          <div className="flex gap-4 h-full">
            <div className="flex-1 max-w-5xl">
              <ChatInterface user={user} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
